module.exports = __webpack_public_path__ + "img/yjkbx.4a552485.png";